export default __webpack_public_path__ + "media/images/mailer/wordmark-ca7b0a94ead3add754f19a959891d786.png";